import React from 'react';

export const SvgCollapse = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.69 11.998l4.009 4.01a1.045 1.045 0 010 1.452 1.027 1.027 0 01-1.454 0l-4.73-4.74a1.026 1.026 0 010-1.453l4.73-4.73A1.026 1.026 0 1118.7 7.99l-4.01 4.008zm-7.214 0l4.009 4.01a1.045 1.045 0 010 1.452 1.026 1.026 0 01-1.453 0l-4.73-4.74a1.026 1.026 0 010-1.453l4.73-4.73a1.026 1.026 0 111.453 1.453l-4.01 4.008z"
      fill="currentColor"
    />
  </svg>
);
